export default __webpack_public_path__ + "static/media/thumbnail_blog_24.7c43fe3f.jpg";